import * as Sentry from '@sentry/react';
import { createRoot } from "react-dom/client";
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import App from "./App.tsx";
import { observarVersaoNova } from "./lib/avisoDeVersao";
import "./index.css";

// Initialize Sentry (only in production with a DSN configured)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}

// Avisa a aba aberta quando um deploy novo assume — sem recarregar sozinho,
// que no meio de uma aula seria pior que a tela desatualizada.
observarVersaoNova();

/* ABA ANTIGA + DEPLOY NOVO = chunk lazy que não existe mais (o rsync --delete
   apaga os hashes velhos). Sem isto, a primeira navegação depois de um deploy
   quebra numa tela morta que PARECE logout — foi um dos dois golpes que
   apagaram a aula de 06/08. O Vite avisa com `vite:preloadError`; recarregar
   pega o bundle novo. O guarda de sessionStorage impede loop se o erro for
   outro (ex.: sem rede). */
window.addEventListener('vite:preloadError', (event) => {
  const JA_TENTOU = 'preload-error-reload';
  const ultima = Number(sessionStorage.getItem(JA_TENTOU) ?? 0);
  if (Date.now() - ultima < 30_000) return; // reload há <30s não resolveu: deixa o erro aparecer
  sessionStorage.setItem(JA_TENTOU, String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(<App />);
